<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
            @shown="focusSearch"
            @closeUpload="closeUpload"
        >
            <template #modal-title>
                Add SBP Media
            </template>
            <div class="d-flex w-100 justify-content-end">
                <div class="btn btn-success mr-3" @click="openAddMedia">Add Media</div>
            </div>
            <related-media-search
                ref="related-media-search"
                :publication="publication"
                :article="article"
                :article_related_media="article_related_media"
                :type="type"
                :bulk="bulk"
                @link="linkItem"
                @unlink="unlinkItem"
                @selected-change="selected_related_media_count = $event"
            />

            <template #modal-footer>
                <b-button
                    v-if="bulk"
                    variant="primary"
                    :disabled="!selected_related_media_count"
                    @click="addSelectedRelatedMedia"
                >
                    Add Media ({{ selected_related_media_count }})
                </b-button>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Cancel
                </b-button>
            </template>
        </b-modal>

        <upload-media-modal
            v-model="show_upload_media_modal"
            :type="type"
            :value="null"
            @hideUploadMedia="show_upload_media_modal = false"
            @link="linkItem"
        />
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

import RelatedMediaSearch from '@/components/modals/article/related_media/Search'
import UploadMediaModal from '@/components/modals/media/UploadMediaModal'

export default {
    data: () => ({
        show_upload_media_modal: false,
        selected_related_media_count: 0
    }),
    props: {
        value: {},
        publication: {},
        article: {},
        article_related_media: {},
        type: {},
        bulk: {
            type: Boolean,
            default: false
        }
    },
    components: {
        RelatedMediaSearch,
        UploadMediaModal
    },
    computed: {
        ...mapState({

        }),
        modal_id() {
            let modal_id = 'add-related-media-modal'
            return modal_id
        }
    },
    methods: {
        linkItem (item, width, position) {
            this.$set(item, 'linking', true)
            this.$emit('link', item, width, position)
        },
        async addSelectedRelatedMedia() {
            if (this.$refs['related-media-search']) {
                const selected_items = await this.$refs['related-media-search'].addSelectedItems()

                if (!selected_items || !selected_items.length) {
                    return
                }

                _.forEach(selected_items, selected_item => {
                    this.$set(selected_item.item, 'linking', true)
                })
                this.$refs['related-media-search'].resetSelectedItems()

                this.$emit('link-multiple', selected_items)
            }
        },
        unlinkItem (item) {
            this.$swal({
                html: 'Are you sure you want to unlink this item?',
                showCancelButton: true,
                confirmButtonText: 'Unlink Item',
                confirmButtonColor: '#E67E22',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.$emit('unlink', item)
                }
            })
        },
        focusSearch() {
            if (
                this.$refs['related-media-search'] &&
                this.$refs['related-media-search'].$refs['search-term']
            ) {
                this.$refs['related-media-search'].$refs['search-term'].focus()
            }
        },
        cancel (event) {
            event.preventDefault()
            this.hide()
        },
        hide() {
            this.$emit('hide')
        },
        hidden() {
            this.$emit('hide')
        },
        closeUpload(){

        },
        openAddMedia(){
            this.show_upload_media_modal = true;
        },
    }
}
</script>
